export const ERROR_UNKNOWN = 'unknown'
export const ERROR_EMAIL_ALREADY_IN_USE = 'emailAlreadyInUse'



// WEBPACK FOOTER //
// ./src/services/signup/constants.js